<template>
    <b-modal v-model="show" :no-close-on-esc="true" :no-close-on-backdrop="true" size="lg">
        <div slot="modal-header">
            <b><span class="text-success">Қўшимча харажатлар</span></b>
        </div>
        <div class="container-fluid pl-0 pr-0" style="height: 400px; overflow-y: scroll">
            <div class="row">
                <div class="col-12 table-responsive">
                  <div class="table-wrapper">
                    <table class="table table-bordered text-center" style="min-width: 600px;">
                        <tr class="font-weight-bold">
                            <td width="40%">Қурилма номи<code>*</code></td>
                            <td width="10%">Миқдори<code>*</code></td>
                            <td width="20%">Нархи</td>
                            <td width="20%">Умумий нархи</td>
                            <td width="10px">Ўчириш</td>
                        </tr>
                        <tr v-for="(item, index) in smallAutoPartsItemList" :key="index">
                            <td>
                                <v-select v-model="item.smallAutoPartsDto"
                                          :options="autoParts"
                                          @search="onAutoPartsSearch"
                                          @search:focus="onAutoPartsFocus"
                                          label="name"
                                          @change="changePrices(item)"
                                >
                                    <template slot="option" slot-scope="option" v-if="option">
                                        <div v-html="option.name"></div>
                                    </template>

                                    <template slot="selected-option"
                                              v-if="item && item.smallAutoPartsDto && item.smallAutoPartsDto.name">
                                        <div v-html="item.smallAutoPartsDto.name"
                                             @click="$eventBus.$emit('search:focus')"
                                        >
                                        </div>
                                    </template>
                                    <span slot="no-options">{{$t("empty")}}</span>
                                </v-select>
                                <div class="red" v-if="$v.smallAutoPartsItemList.$each[index].smallAutoPartsDto.$error">
                                    Қурилма номи
                                </div>
                            </td>
                            <td>
                                <numeric-input class="form-control" v-model="item.qty"
                                               :class="{invalid : $v.smallAutoPartsItemList.$each[index].qty.$error}"
                                               :controls="false" :precision="0"
                                               @input="changePrices(item)"></numeric-input>
                                <div class="red" v-if="$v.smallAutoPartsItemList.$each[index].qty.$error">
                                    Миқдори
                                </div>
                            </td>
                            <td class="text-center">
                                    <span class="font-weight-bold" style="color: green;">
                                        {{item.price}}
                                    </span>
                            </td>
                            <td class="text-center">
                                    <span class="font-weight-bold" style="color: green;">
                                        {{item.amount}}
                                    </span>
                            </td>
                            <td style="white-space: nowrap">
                                <button type="button" class="all-btn delete-btn" @click="remove(index)">
                                    <i class="fa fa-remove"></i>
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>Жами </b>
                            </td>
                            <td colspan="2">
                            </td>
                            <td>
                                <b><span class="text-success">{{totalPrice | currency('', 0, { thousandsSeparator: ' ' })}}</span></b>
                            </td>
                            <td><b><span class="text-success">сўм</span></b></td>
                        </tr>
                    </table>
                  </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3">
            <button class="all-btn add-btn float-right ml-5" @click="finish">
                Тайёр
            </button>
            <button class="all-btn float-right" @click="add">
                Қўшиш
            </button>
        </div>
    </b-modal>
</template>

<script>

    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import initFilterModel from '@/shared/filter';
    import {required, minValue} from 'vuelidate/lib/validators';

    export default {
        name: "SmallParts",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                autoPartFilter: initFilterModel(),
                autoDefect: {},
                autoParts: [],
                smallAutoPartsItemList: [],
                totalPrice: 0
            }
        },
        validations() {
            return {
                smallAutoPartsItemList: {
                    $each: {
                        smallAutoPartsDto: {
                            required: required
                        },
                        qty: {
                            required: required,
                            minValue: minValue(1)
                        }
                    }
                }
            }
        },
        methods: {
            add() {
                const vm = this;
                vm.lastObj = {
                    qty: 0,
                    price: 0
                };
                vm.smallAutoPartsItemList.push(vm.lastObj);
            },
            finish() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.autoDefect.smallAutoPartsItemDtos = [];
                this.autoDefect.smallAutoPartsItemDtos = this.smallAutoPartsItemList;
                this.show = false;
                this.$eventBus.$emit('AutoDefectAct', this.autoDefect);
            },
            remove(index) {
                this.smallAutoPartsItemList.splice(index, 1);
                this.calculateTotalPrice();
            },
            onAutoPartsSearch(searchTxt, loading) {
                loading(true);
                this.autoPartFilter.search = searchTxt;
                this.searchMethod(loading);
            },
            onAutoPartsFocus() {
                this.autoPartFilter.search = '';
                this.searchMethod();
            },
            searchMethod(loading) {
                this.autoParts = [];
                this.$http.post('auto-part/small', this.autoPartFilter)
                    .then(res => {
                        if (loading)
                            loading(false);
                        this.autoParts = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            changePrices(item) {
                item.price = item.smallAutoPartsDto.price;
                item.amount = item.qty * item.smallAutoPartsDto.price;
                item.smallAutoPartsPriceId = item.smallAutoPartsDto.smallAutoPartsPriceId;
              this.calculateTotalPrice();
            },
            calculateTotalPrice() {
                this.totalPrice = 0;
                this.smallAutoPartsItemList.forEach((small) => {
                    this.totalPrice += small.amount;
                });
            }
        },
        created() {
            this.$eventBus.$on('SmallParts', (autoDefect) => {
                this.show = true;
                this.autoDefect = autoDefect;
                if (this.autoDefect.smallAutoPartsItemDtos) {
                    this.smallAutoPartsItemList = this.autoDefect.smallAutoPartsItemDtos;
                    this.calculateTotalPrice();
                } else {
                    this.smallAutoPartsItemList = []
                }
            });
        }
    }
</script>

<style scoped>

</style>